import { render, staticRenderFns } from "./LibraryTagsPage.vue?vue&type=template&id=fbee4cac&scoped=true"
import script from "./LibraryTagsPage.vue?vue&type=script&lang=js"
export * from "./LibraryTagsPage.vue?vue&type=script&lang=js"
import style0 from "./LibraryTagsPage.vue?vue&type=style&index=0&id=fbee4cac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbee4cac",
  null
  
)

export default component.exports